// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3yqrw","selected":"Chip_selected__3-bPw"};